import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import LoaderButton from '../../core/components/LoaderButton'
import {DEFAULT_CONTACT_QUERY, sendAssignActivityToProviderContactCmd, queryContactStream} from '../../provider/actions'
import ActivityPicker from './ActivityPicker'
import {ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED, sendAssociateActivityWithOpeningTicketPurposeAction, updateAssociateActivityWithOpeningTicketPurposeAction, loadOpeningTicketPurposeRef} from '../actions'
import {AssociateActivityWithOpeningTicketPurposeAction} from '../models'
import i18n from '../i18n'
import style from './AssociateActivityWithOpeningTicketPurposeModal.less'

class AssociateActivityWithOpeningTicketPurposeModal extends Component {
    static propTypes = {
        openingTicketPurpose: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            selectedProviderContacts: []
        }
    }

    componentWillMount() {
        const {dispatch, openingTicketPurpose} = this.props
        dispatch(updateAssociateActivityWithOpeningTicketPurposeAction({uid: openingTicketPurpose, activityUid: undefined}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openingTicketPurpose != this.props.openingTicketPurpose) {
            const {dispatch, openingTicketPurpose} = nextProps
            dispatch(updateAssociateActivityWithOpeningTicketPurposeAction({uid: openingTicketPurpose, activityUid: undefined}))
        }
        if (nextProps.action && nextProps.action.activityUid != (this.props.action && this.props.action.activityUid)) {
            const {dispatch, action, company} = nextProps

            if (action.activityUid) {
                dispatch(queryContactStream({...DEFAULT_CONTACT_QUERY, activityUids: action.activityUid.uid, companyUid: company.uid, range: {offset: 0, limit: 999}}))
            }
        }
        if (nextProps.providerContactStream != this.props.providerContactStream) {
            this.setState({selectedProviderContacts: []})
        }
    }

    _sendAction() {
        const {dispatch, action, openingTicketPurpose} = this.props
        const {selectedProviderContacts} = this.state

        const activity = action.activityUid

        return dispatch(sendAssociateActivityWithOpeningTicketPurposeAction()).then(() => {
            return Promise.all(selectedProviderContacts.map((providerContact) => {
                const providerContactActivity = providerContact.activities.find((a) => a.activityUid == activity.uid)

                if (providerContactActivity) {
                    const incidentTypeIds = [...providerContactActivity.includedIncidentTypes, openingTicketPurpose.uid]
                    return dispatch(sendAssignActivityToProviderContactCmd(activity, incidentTypeIds, providerContact))
                } else {
                    console && console.warn('Activity "' + activity.uid + '" should be associated with ProviderContact "' + providerContact.uid + '"')
                }
            }))
        }).then(() => {
            return dispatch(loadOpeningTicketPurposeRef())
        })
    }

    _selectAllProviderContacts() {
        const {providerContactStream} = this.props
        const {selectedProviderContacts} = this.state

        this.setState({selectedProviderContacts: providerContactStream})
    }

    _unselectAllProviderContacts() {
        const {selectedProviderContacts} = this.state

        this.setState({selectedProviderContacts: []})
    }

    render() {
        const {dispatch, form, action, providerContactStream, providerContactQuery, openingTicketPurpose, company, onHide, ...others} = this.props
        const {selectedProviderContacts} = this.state

        const providerContactSource = matcher({
            source: providerContactStream,
            identify: (pc) => [pc.name.firstName, pc.name.lastName, pc.name.value].filter((v) => v).join(' ')
        })

        const providerContactHeader = (
            <div className={style.providerContactActions}>
                <Button
                    bsStyle='link'
                    onClick={() => this._selectAllProviderContacts()}>
                    {i18n.selectAll}
                </Button>
                <span>|</span>
                <Button
                    bsStyle='link'
                    onClick={() => this._unselectAllProviderContacts()}>
                    {i18n.unselectAll}
                </Button>
            </div>
        )

        const displayActivity = (activity, mode) => {
            if (mode == 'Picked') {
                return (
                    <h4>{activity.label}</h4>
                )
            }
            return activity.label
        }

        const providerContactsField = () => {
            const value = selectedProviderContacts

            const onChange = (value) => {
                this.setState({selectedProviderContacts: value})
            }

            return {value, onChange}
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.associateActivity}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ActivityPicker
                        display={displayActivity}
                        disable={(a) => openingTicketPurpose.activities.find((otpa) => otpa.uid == a.uid)}
                        {...form.activityUid()} />
                        {providerContactStream.length > 0 && (action && action.activityUid && action.activityUid.uid == (providerContactQuery && providerContactQuery.activityUids)) && (
                            <div className={style.providerContacts}>
                                <div className={style.text}>
                                    {i18n.associateActivityText.map((text, index) => (
                                        <p key={index}>{text}</p>
                                    ))}
                                </div>
                                <TypeaheadBar split
                                    size='small'
                                    header={providerContactHeader}
                                    placeholder={i18n.searchProviderContact}
                                    source={providerContactSource}
                                    display={(pc) => [pc.name.firstName, pc.name.lastName, pc.name.value].filter((v) => v).join(' ')}
                                    identify={(pc) => pc.uid}
                                    {...providerContactsField()} />
                            </div>
                        )}
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

AssociateActivityWithOpeningTicketPurposeModal = connectForm({
    target: 'action',
    schema: AssociateActivityWithOpeningTicketPurposeAction.schema,
    action: ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED
})(AssociateActivityWithOpeningTicketPurposeModal)

AssociateActivityWithOpeningTicketPurposeModal = connect((state) => ({
    action: state.reference.associateActivityWithOpeningTicketPurposeAction,
    providerContactStream: state.provider.contact.stream,
    providerContactQuery: state.provider.contact.query,
    company: state.company.company
}))(AssociateActivityWithOpeningTicketPurposeModal)

export default AssociateActivityWithOpeningTicketPurposeModal


// WEBPACK FOOTER //
// ./lib/reference/components/AssociateActivityWithOpeningTicketPurposeModal.js